const MFA_CHALLENGE_KEY = 'torre_mfa_challenge'

export function saveMfaToken(payload) {
  const challenge = typeof payload === 'string' ? { mfa_token: payload } : payload
  sessionStorage.setItem(MFA_CHALLENGE_KEY, JSON.stringify(challenge))
}

export function loadMfaToken() {
  const raw = sessionStorage.getItem(MFA_CHALLENGE_KEY)
  if (!raw) return null

  try {
    const parsed = JSON.parse(raw)
    return parsed?.mfa_token ? parsed : null
  } catch (_error) {
    return { mfa_token: raw }
  }
}

export function clearMfaToken() {
  sessionStorage.removeItem(MFA_CHALLENGE_KEY)
}
